import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { LoadingButton } from "@mui/lab";
import { PageContainer } from "@/features/ui";

import { DeliveryCustomerClaimForm } from "@/features/customer-claims/delivery-customer-claim-form";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

export const CreateDeliveryCustomerClaim = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { receiveClaimReferenceNumber } = useParams();
  const [receiveClaimData, setReceiveClaimData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReceiveClaim = async () => {
      try {
        setLoading(true);
        const response = await apiOutletClient.get(
          `customer-claims/${receiveClaimReferenceNumber}`
        );
        setReceiveClaimData(response.data.data);
      } catch (error) {
        showSnackbar(
          `Gagal memuat klaim terima: ${getErrorMessage(error, "Gagal membuat klaim kirim barang")}`
        );
        navigate("/sales/customer-claims/receive");
      } finally {
        setLoading(false);
      }
    };

    fetchReceiveClaim();
  }, [receiveClaimReferenceNumber, showSnackbar, navigate]);

  const handleSubmit = async (formData) => {
    try {
      // Extract sellerId for header, remove it from payload
      const { sellerId, ...payload } = formData;

      await apiOutletClient.post(
        `customer-claims/${receiveClaimReferenceNumber}/delivery`,
        payload,
        {
          headers: {
            "Outlet-Id": sellerId,
          },
        }
      );
      navigate("/sales/customer-claims/delivery");
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal membuat klaim kirim barang"));

      throw error;
    }
  };

  if (loading) {
    return null;
  }

  if (!receiveClaimData) {
    return null;
  }

  return (
    <PageContainer maxWidth="xl" title="Buat Klaim Kirim Barang">
      <DeliveryCustomerClaimForm
        onSubmit={handleSubmit}
        receiveClaimData={receiveClaimData}
        defaultValues={{
          seller: receiveClaimData.seller,
          buyer: receiveClaimData.buyer,
          buyerableType: receiveClaimData.buyerableType,
          warehouse: receiveClaimData.warehouse,
          customerClaimProductVariants:
            receiveClaimData.customerClaimProductVariants.map((variant) => ({
              ...variant,
              selected: false, // Initially unselected
            })),
        }}
        renderActionButton={({ isSubmitting }) => (
          <LoadingButton
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </LoadingButton>
        )}
      />
    </PageContainer>
  );
};
